import { debounce } from '../../core/helpers';

const stickySummary = () => {
  const stickySummaryElement = document.querySelector('[data-cart-summary="desktop"] [data-sticky-summary]');

  if (!stickySummaryElement) {
    return;
  }

  const isMobileOrTablet = ['mobile', 'tablet'].includes(window.theme.breakpoints.current);
  if (isMobileOrTablet) {
    stickySummaryElement.style.top = '0px';
    return;
  }

  const pageScrollTop = window.scrollY;
  const header = document.querySelector('.shopify-section.header');
  const footer = document.querySelector('footer.shopify-section-group-footer-group');
  const parentPaddingTop = parseInt(window.getComputedStyle(stickySummaryElement.parentElement).paddingTop, 10);

  let stickySummaryTop = 0;

  if (header) {
    stickySummaryTop = (pageScrollTop <= header.offsetHeight + parentPaddingTop)
      ? parentPaddingTop
      : (parentPaddingTop + pageScrollTop) - header.offsetHeight;
  }

  // Prevent summary from going under the footer
  if (footer) {
    const maxTop = footer.offsetTop - stickySummaryElement.offsetHeight - (parentPaddingTop * 2) - (header?.offsetHeight || 0) - 50;
    if (stickySummaryTop >= maxTop) {
      stickySummaryTop = maxTop;
    }
  }

  stickySummaryElement.style.top = `${stickySummaryTop}px`;
};

export default () => {
  stickySummary();

  window.addEventListener('scroll', debounce(() => {
    stickySummary();
  }, 10));

  window.addEventListener('load', () => {
    stickySummary();
  });
};
